import React from "react";
import { fmtNumber } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Gauge } from "lucide-react";

function Empty({ msg }) {
  return (
    <div className="h-[120px] flex items-center justify-center text-sm text-muted-foreground text-center px-4">
      {msg}
    </div>
  );
}

const dash = (v) => (v === null || v === undefined ? "—" : v);

export default function RepEfficiency({ efficiency, cycle }) {
  const eff = efficiency || [];
  const cycleByOwner = {};
  (cycle || []).forEach((c) => {
    cycleByOwner[c.owner_id] = c.avg_cycle_days;
  });

  return (
    <Card data-testid="rep-efficiency">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <Gauge className="w-4 h-4 text-primary" /> Rep Efficiency
          <span className="text-xs font-normal text-muted-foreground ml-1">· in period</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {eff.length ? (
          <div className="max-h-[280px] overflow-y-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Rep</TableHead>
                  <TableHead className="text-right">Activities</TableHead>
                  <TableHead className="text-right">Won</TableHead>
                  <TableHead className="text-right">Act/Win</TableHead>
                  <TableHead className="text-right">Mtg/Win</TableHead>
                  <TableHead className="text-right">Avg Cycle</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {eff.map((r) => (
                  <TableRow key={r.owner_id}>
                    <TableCell className="font-medium text-foreground">{r.name}</TableCell>
                    <TableCell className="text-right">{fmtNumber(r.activities)}</TableCell>
                    <TableCell className="text-right">{fmtNumber(r.won)}</TableCell>
                    <TableCell className="text-right text-muted-foreground">
                      {dash(r.activities_per_win)}
                    </TableCell>
                    <TableCell className="text-right text-muted-foreground">
                      {dash(r.meetings_per_win)}
                    </TableCell>
                    <TableCell className="text-right text-muted-foreground">
                      {cycleByOwner[r.owner_id] != null ? `${cycleByOwner[r.owner_id]}d` : "—"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : (
          <Empty msg="No rep activity/win data for this period." />
        )}
      </CardContent>
    </Card>
  );
}
